import axios from 'axios';

export default {
  getList(_, params) {
    return axios.get('CandidateDetection/GetList', { params });
  },
  reject(_, id) {
    return axios.get('CandidateDetection/Reject', { params: { id } });
  },
  approve(_, id) {
    return axios.get('CandidateDetection/Approve', { params: { id } });
  },
};
